export const ALLOY_KEY_PREFIX = 'alloy-swr-';
export const baseParser = value => value === 'undefined' || value === null ? undefined : JSON.parse(value);
export const setDataInStorage = (data, key) => {
  try {
    sessionStorage.setItem("".concat(ALLOY_KEY_PREFIX).concat(key), JSON.stringify(data));
  } catch (_unused) {
    // Ignore till we find a better way to handle it
  }
};
//# sourceMappingURL=commonCache.js.map